module.exports = __webpack_public_path__ + "static/media/e.f851429c.png";